import axios from "axios";
import { toast } from "react-toastify";

export const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to dynamically set the Authorization header
http.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");

    if (token && token !== "null" && token !== "undefined") {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  function (response: any) {
    // Add backward compatibility for paginated responses
    if (response.data?.data && response.data?.data?.pagination) {
      // Add count property for backward compatibility
      response.data.data.count = response.data.data.pagination.total;

      // Add type-specific array properties for backward compatibility
      if (Array.isArray(response.data.data.data)) {
        const dataArray = response.data.data.data;

        // Infer type and add appropriate property
        if (dataArray.length > 0) {
          const firstItem = dataArray[0];

          // Check for specific type indicators and add appropriate property
          if (firstItem.session_date || firstItem.patient_profile_id) {
            response.data.data.sessions = dataArray;
          } else if (firstItem.patient_id || firstItem.fullName) {
            response.data.data.patients = dataArray;
          } else if (firstItem.clinician_id || firstItem.experience) {
            response.data.data.clinicians = dataArray;
          } else if (firstItem.payout_id || firstItem.payment_method) {
            response.data.data.payouts = dataArray;
          } else if (
            firstItem.serviceId ||
            (firstItem.title && firstItem.description)
          ) {
            response.data.data.services = dataArray;
          } else if (firstItem.title && firstItem.arabic) {
            // Symptoms have title and arabic fields
            response.data.data.symptoms = dataArray;
          } else if (firstItem.consultation_mode) {
            response.data.data.consultations = dataArray;
          } else if (firstItem.rating || firstItem.review_id) {
            response.data.data.reviews = dataArray;
          }
        }
      }
    }

    return response;
  },
  function (err: any) {
    if (err.message === "Network Error") {
      alert("Network Error");
    }
    if (
      err.response.data.statusCode === 401 &&
      err.response.config.method === "get"
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("userType");
      window.location.href = "/login";
    }
    // Handle 403 Forbidden errors
    if (err.response?.status === 403) {
      toast.error(
        "Access denied: You don't have permission to perform this action."
      );
    }
    return Promise.reject(err);
  }
);
